import { useMemo } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQueryParams } from 'use-query-params';

import { useDataExplorerSuspenseConfigurationV2 } from '@packages/hooks/use-data-explorer-suspense-configuration-v2/use-data-explorer-suspense-configuration-v2';
import { DayJsParam } from '@packages/utils/dayjs.utils';

const useDefaultDateRangeSearchParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const {
    datePicker: { getDefaultDateRange },
  } = useDataExplorerSuspenseConfigurationV2();

  const [start, end] = useMemo(
    () => getDefaultDateRange(),
    [getDefaultDateRange],
  );

  searchParams.set('start', start.utc().toISOString());
  searchParams.set('end', end.utc().toISOString());

  return searchParams;
};

export const DefaultDateRangeGuard = () => {
  const [{ start, end }] = useQueryParams({
    start: DayJsParam,
    end: DayJsParam,
  });
  const location = useLocation();
  const searchParams = useDefaultDateRangeSearchParams();

  if (start && end) {
    return <Outlet />;
  }

  return (
    <Navigate
      replace
      to={{ pathname: location.pathname, search: searchParams.toString() }}
      state={location.state}
    />
  );
};
